<template>
    <div id="ContractTypeSectionMapperCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="contractTypeSectionMapperHeader" v-if="$route.params.id > 0">Update Contract Type Section Mapper</span>
                    <span class="page-title" id="contractTypeSectionMapperHeader" v-else>Add Contract Type Section Mapper</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackContractTypeSectionMapperList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contracttype-section-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container contract-mapper" id="ContractTypeSectionMapperForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                        <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                label="text"
                                                :options="contractTypeArr">
                                        </v-select>
                                        <div class="field-error">{{ contract_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_type_id">Asset Type:</label>
                                        <v-select v-model="vehicle_type_id" name="vehicle_type_id" placeholder="Select Asset Type."
                                                label="text"
                                                :options="vehicleTypeArr">
                                        </v-select>
                                        <div class="field-error">{{ vehicle_type_error_msg }}</div>
                                    </div>
                                </div>
                                <div v-for="(line, index) in lines" v-bind:key="index" class="form-row">
                                    <div class="col-md-3 form-group">
                                        <label class="control-label require" for="line.section_id">Section:</label>
                                        <v-select class="section-id" v-model="line.section_id" name="line.section_id" placeholder="Select Section Rate."
                                                label="text"
                                                :options="sectionArr">
                                        </v-select>
                                        <div class="field-error">{{ line.section_error_msg }}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label require" for="line.section_value">Rate:</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend"><span id="" class="input-group-text">$</span></div>
                                            <input type="number" class="form-control section-value" v-model="line.section_value" id="line.section_value" placeholder="Value" name="line.section_value" aria-describedby="basic-addon4" @keypress="isAmountCheck($event)">   
                                        </div>
                                        <div class="field-error">{{ line.section_value_error_msg }}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="line.cpi_increase_percent">CPI:</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model="line.cpi_increase_percent" id="line.cpi_increase_percent" placeholder="CPI" name="line.cpi_increase_percent" aria-describedby="basic-addon4" @keypress="isAmountCheck($event)">
                                            <div class="input-group-append"><span id="" class="input-group-text">$</span></div>
                                        </div>
                                        <div class="field-error">{{ line.cpi_increase_error_msg }}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="line.rate_increase_percent">Rate:</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model="line.rate_increase_percent" id="line.rate_increase_percent" placeholder="Rate" name="line.rate_increase_percent" aria-describedby="basic-addon4" @keypress="isAmountCheck($event)">
                                            <div class="input-group-append"><span id="" class="input-group-text">$</span></div>
                                        </div>
                                        <div class="field-error">{{ line.rate_increase_error_msg }}</div>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <label class="control-label" for="line.limit_percent">Limit:</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model="line.limit_percent" id="line.limit_percent" placeholder="Limit" name="line.limit_percent" aria-describedby="basic-addon4" @keypress="isAmountCheck($event)">
                                            <div class="input-group-append"><span id="" class="input-group-text">$</span></div>
                                        </div>
                                        <div class="field-error">{{ line.limit_percent_error_msg }}</div>
                                    </div>
                                    <div class="col-md-1 form-group mt-4 pt-1">
                                        <template>
                                            <a href="" class="fp-remove" v-on:click.prevent="removeLine(index)"></a>
                                        </template>
                                        <label>&nbsp;&nbsp;</label>
                                        <template>
                                            <a href="" class="fp-plus" v-if="index + 1 === lines.length" v-on:click.prevent="addLine($event,index)"></a>
                                        </template>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateContractTypeSectionMapperBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateContractTypeSectionMapper" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateContractTypeSectionMapperBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateContractTypeSectionMapper" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueContractTypeSectionMapperBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateContractTypeSectionMapper(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelContractTypeSectionMapperBtn" class="btn btn-tertiary" v-on:click.prevent="BackContractTypeSectionMapperList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "ContractTypeSectionMapperCreate",
  
  mixins:[commonMixins,contractMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Contract Type Section Mapper | " +process.env.COPYRIGHT_NAME : "Create Contract Type Section Mapper | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    contract_type_id: null,
    contractTypeArr: [],
    contract_type_error_msg: "",
    vehicle_type_id: null,
    vehicleTypeArr: [],
    vehicle_type_error_msg: "",
    section_id: null,
    arr: [],
    sectionArr: [],
    section_value: "",
    section_value_error_msg: "",
    section_error_msg: "",
    cpi_increase_percent: "",
    cpi_increase_error_msg: "",
    rate_increase_percent: "",
    rate_increase_error_msg: "",
    limit_percent: "",
    limit_percent_error_msg: "",
    lines: [],
    blockRemoval: true,
    loading:false,
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_contract_type_section_mapper') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

        vehicle_type_id:function(old_vehicle,vehicle_type_id) {
            var self = this;
            if (self.contract_type_id.value != undefined && self.vehicle_type_id.value != undefined) {

                self.getSectionData(self.contract_type_id.value, self.vehicle_type_id.value);
            }
            // else {
            //         console.log(self.contract_type_id.value,self.vehicle_type_id.value);
            //
            //         // alert("Please Select Contract Type Id!");
            // }
        },

        lines () {
            var self = this;
            self.blockRemoval = self.lines.length <= 1
        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadContractTypeSectionMapper();    
        }
        //self.getContractAssetData();
        this.loadFieldData(['contractType','vehicleType']);
        //self.addLine(this);
        self.lines.push({

            section_id: null,
            section_value: null,
            cpi_increase_percent: null,
            rate_increase_percent: null,
            limit_percent: null,
            section_error_msg: "",
            section_value_error_msg: "",
            // cpi_increase_error_msg: "",
            // rate_increase_error_msg: "",
            // limit_percent_error_msg: "",
        })
        
  },
  methods: {

    addLine ($event, index) {

        var self = this;
        self.lines[index].section_value_error_msg = "";
        self.lines[index].section_error_msg = "";
        // self.lines[index].cpi_increase_error_msg = "";
        // self.lines[index].rate_increase_error_msg = "";
        // self.lines[index].limit_percent_error_msg = "";

        // console.log(self.lines[index].section_id);
        // console.log(self.lines[index].section_value);
        // console.log($($event.target).closest('.validation-msg').find(".section-value").val());

        var sectionValue = $($event.target).closest('.validation-msg').find('.section-value').val();
        
        // if any of value is 0 if means that value will be null.
        /* if (self.lines[index].section_value == 0) {
            self.lines[index].section_value = null
        }
        if (self.lines[index].cpi_increase_percent == 0) {
            self.lines[index].cpi_increase_percent = null
        }
        if (self.lines[index].rate_increase_percent == 0) {
            self.lines[index].rate_increase_percent = null
        }
        if (self.lines[index].limit_percent == 0) {
            self.lines[index].limit_percent = null
        } */
            
        // if ( self.lines[index].section_value != null && self.lines[index].section_id != null && self.lines[index].cpi_increase_percent != null && 
        //         self.lines[index].rate_increase_percent != null && self.lines[index].limit_percent != null) {
        if ( self.lines[index].section_value != null && self.lines[index].section_id != null ) {            

            self.lines.push({

                section_id: null,
                section_value: null,
                cpi_increase_percent: null,
                rate_increase_percent: null,
                limit_percent: null,
                section_error_msg: "",
                section_value_error_msg: "",
                // cpi_increase_error_msg: "",
                // rate_increase_error_msg: "",
                // limit_percent_error_msg: "",
            })

        } else {

            if (self.lines[index].section_id == null || !self.lines[index].section_id.value) {

                self.lines[index].section_error_msg = "Section Rate Required.";
            }

            if (self.lines[index].section_value == null || self.lines[index].section_value == "" || self.lines[index].section_value == 0) {
                
                self.lines[index].section_value_error_msg = "Section Value Required.";
            }

            /*if (self.lines[index].cpi_increase_percent == null || self.lines[index].cpi_increase_percent == "" || self.lines[index].cpi_increase_percent == 0) {
                
                self.lines[index].cpi_increase_error_msg = "CPI Percent Required.";
            }

            if (self.lines[index].rate_increase_percent == null || self.lines[index].rate_increase_percent == "" || self.lines[index].rate_increase_percent == 0) {
                
                self.lines[index].rate_increase_error_msg = "Rate Percent Required.";
            }

            if (self.lines[index].limit_percent == null || self.lines[index].limit_percent == "" || self.lines[index].limit_percent == 0) {
                
                self.lines[index].limit_percent_error_msg = "Limit Percent Required.";
            }*/
        }
         
    },
    
    removeLine (lineId) {
        
        var self = this;
        if (!self.blockRemoval) self.lines.splice(lineId, 1)
    },

    /* get section rate for contract type id and asset type id.*/
    getSectionData(contract_type_id, vehicle_type_id){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/contracttypesectionmapper/section-rate",
            type: "GET",
            data:{
                'contract_type_id': contract_type_id,
                'vehicle_type_id': vehicle_type_id,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    
                    self.sectionArr = data.section_rate;
                } 
            },
            error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR,true,'create-contract-type-section-mapper-get')
            }
        });
    },

    BackContractTypeSectionMapperList() {
      var self = this;
      self.$router.push("/contracttypesectionmapper/list");
    },

    CreateContractTypeSectionMapper(flag) {
      var self = this;
      var error = false;

      var storeSectionIdArr = [];
      var storeSectiocValueArr = [];
      var storeCPIArr = [];
      var storeRateArr = [];
      var storeLimitArr = [];

      // Store for particular value in array.
    //   for (var i=0; i<self.lines.length; i++) {
          
    //       if (self.lines[i].section_id != null) {
            
    //         storeSectionIdArr.push(self.lines[i].section_id.value);
    //         storeSectiocValueArr.push(self.lines[i].section_value);
    //         storeCPIArr.push(self.lines[i].cpi_increase_percent);
    //         storeRateArr.push(self.lines[i].rate_increase_percent);
    //         storeLimitArr.push(self.lines[i].limit_percent);
    //       }
    //   }

      self.contract_type_error_msg = "";
      self.vehicle_type_error_msg = "";

      if (self.contract_type_id == null || !self.contract_type_id.value) {
        self.contract_type_error_msg = "Contract Type Required.";
        error = true;
      }

      if (self.vehicle_type_id == null || !self.vehicle_type_id.value) {
        self.vehicle_type_error_msg = "Asset Type Required.";
        error = true;
      }

        for (var i=0; i<self.lines.length; i++) {

            self.lines[i].section_error_msg = "";
            self.lines[i].section_value_error_msg = "";

            if ( self.lines[i].section_id != undefined && storeSectionIdArr.includes(self.lines[i].section_id.value)) {
                self.lines[i].section_error_msg = "This Section Rate has been already added.";
                error = true;
            }
            
            if (self.lines[i].section_id == null || !self.lines[i].section_id.value) {

                self.lines[i].section_error_msg = "Section Rate Required.";
                error = true;
            }else {
                storeSectionIdArr.push(self.lines[i].section_id.value);
            }

            if (self.lines[i].section_value == null || self.lines[i].section_value == 0) {
                
                self.lines[i].section_value_error_msg = "Section Value Required.";
                error = true;
            }
            
        }
      
      if (!error) {
           // Store for particular value in array.
            for (var i=0; i<self.lines.length; i++) {
                
                // if (self.lines[i].section_id != null) {
                    
                    // storeSectionIdArr.push(self.lines[i].section_id.value);
                    storeSectiocValueArr.push(self.lines[i].section_value);
                    storeCPIArr.push(self.lines[i].cpi_increase_percent);
                    storeRateArr.push(self.lines[i].rate_increase_percent);
                    storeLimitArr.push(self.lines[i].limit_percent);
                // }
            }
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateContractTypeSectionMapperBtn").val("Updating ...");
                $("#CreateContractTypeSectionMapperBtn").prop("disabled", true);
                $("#cancelContractTypeSectionMapperBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueContractTypeSectionMapperBtn").val("Saving ...");
                    $("#CreateContractTypeSectionMapperBtn").prop("disabled", true);
                    $("#createAndContinueContractTypeSectionMapperBtn").prop("disabled", true);
                    $("#cancelContractTypeSectionMapperBtn").prop("disabled",true);

                }else{

                    $("#CreateContractTypeSectionMapperBtn").val("Saving ...");
                    $("#CreateContractTypeSectionMapperBtn").prop("disabled", true);
                    $("#createAndContinueContractTypeSectionMapperBtn").prop("disabled", true);
                    $("#cancelContractTypeSectionMapperBtn").prop("disabled",true);
                }
               
            }

            var fields = $("#ContractTypeSectionMapperForm").serializeArray();
            fields.push({name: "contract_type_id", value: self.contract_type_id.value});
            fields.push({name: "vehicle_type_id", value: self.vehicle_type_id.value});
            fields.push({name: "section_id", value: storeSectionIdArr});
            fields.push({name: "section_value", value: storeSectiocValueArr});
            fields.push({name: "cpi_increase_percent", value: storeCPIArr});
            fields.push({name: "rate_increase_percent", value: storeRateArr});
            fields.push({name: "limit_percent", value: storeLimitArr});
            fields.push({name: "id", value: segments[3]});
            
            $.ajax({
                url: process.env.ROOT_API + "/contracttypesectionmapper/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateContractTypeSectionMapperBtn").val("Update");
                        $("#CreateContractTypeSectionMapperBtn").prop("disabled", false);
                        $("#cancelContractTypeSectionMapperBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractTypeSectionMapperBtn").val("Save and Continue");
                            $("#CreateContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#cancelContractTypeSectionMapperBtn").prop("disabled",false);

                        }else{

                            $("#CreateContractTypeSectionMapperBtn").val("Save");
                            $("#CreateContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#cancelContractTypeSectionMapperBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ContractTypeSectionMapperForm").trigger("reset");
                            self.contract_type_id = null;
                            self.vehicle_type_id = null;

                            for (var i=0; i<self.lines.length; i++) {

                                if (i != 0) {
                                    if (!self.blockRemoval) self.lines.splice(i, 1)
                                } else {
                                    self.lines[i].section_id = null;
                                    self.lines[i].section_value = "";
                                    self.lines[i].cpi_increase_percent = "";
                                    self.lines[i].rate_increase_percent = "";
                                    self.lines[i].limit_percent = "";
                                }
                            }
                            
                    
                        }else{
                            self.$router.push("/contracttypesectionmapper/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            // if (data.message == "limit_validation") {
                            //     // err += data.content;
                            //     for (var i = 0; i < data.content.length; i++) {
                            //         err += data.content[i] + "<br>";
                            //     }
                            // } else {
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                            // }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateContractTypeSectionMapperBtn").val("Update");
                        $("#CreateContractTypeSectionMapperBtn").prop("disabled", false);
                        $("#cancelContractTypeSectionMapperBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ContractTypeSectionMapperForm").trigger("reset");
                            

                            $("#createAndContinueContractTypeSectionMapperBtn").val("Save and Continue");
                            $("#CreateContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#cancelContractTypeSectionMapperBtn").prop("disabled",false);

                        }else{

                            $("#CreateContractTypeSectionMapperBtn").val("Save");
                            $("#CreateContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeSectionMapperBtn").prop("disabled", false);
                            $("#cancelContractTypeSectionMapperBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'create-contract-type-section-mapper')
                }
            });
      }else{
            self.errorValidationFocus();
      }
     
    },

    loadContractTypeSectionMapper() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/contracttypesectionmapper/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                
                    self.contract_type_id = {value: data.content.contract_type_id, text: self.formatString(data.content.ctName + " (" + data.content.ctCode + ") ")};
                    self.vehicle_type_id = {value: data.content.vehicle_type_id, text: self.formatString(data.content.vtName + " (" + data.content.vtCode + ") ")};
                    self.lines[0].section_id = {value: data.content.section_id, text: data.content.srName + " (" + data.content.srCode + ") "};
                    self.lines[0].section_value = data.content.section_value;
                    self.lines[0].cpi_increase_percent = data.content.cpi_increase_percent;
                    self.lines[0].rate_increase_percent = data.content.rate_increase_percent;
                    self.lines[0].limit_percent = data.content.limit_percent;
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'contract-type-section-mapper-by-id')
            }
        });
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

    formatString(data) {

        if (data == null){
        }else{
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ContractTypeSectionMapperCreate.vue